type PaginatedResponse<T> = {
  results?: T[];
};

function hasResultsArray<T>(value: unknown): value is PaginatedResponse<T> {
  return Boolean(
    value &&
      typeof value === 'object' &&
      'results' in value &&
      Array.isArray((value as PaginatedResponse<T>).results),
  );
}

export function normalizeListResponse<T>(data: unknown): T[] {
  if (Array.isArray(data)) {
    return data;
  }

  if (hasResultsArray<T>(data)) {
    return data.results ?? [];
  }

  return [];
}
